import React, { useCallback, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { ButtonGroup } from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { MODAL_STATE_FAIL } from '../../types';
import InstallationStatusModal from '../installation-status-modal/main.tsx';
import failure from './assets/failure.png';
import messages from './messages';
import type { Props } from './types';

const FailureStatusModal = ({ analyticsAttributes = {}, onTryAgain, onCancel }: Props) => {
	const { formatMessage } = useIntl();

	const onCancelClick = useCallback(
		(e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'cancelTryAgainLink', analyticsAttributes);
			onCancel && onCancel();
		},
		[analyticsAttributes, onCancel],
	);

	const onTryAgainClick = useCallback(
		(e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'tryAgainButton', analyticsAttributes);
			onTryAgain && onTryAgain();
		},
		[analyticsAttributes, onTryAgain],
	);

	return (
		<>
			<InstallationStatusModal
				imageSrc={failure}
				heading={formatMessage(messages.heading)}
				description={formatMessage(messages.body)}
				installationState={MODAL_STATE_FAIL}
			>
				<ButtonGroup>
					<Button
						onClick={onTryAgainClick}
						appearance="primary"
						autoFocus
						testId="marketplace-dialog.common.ui.failure-status.try-again-button"
					>
						{formatMessage(messages.tryAgainButtonLabel)}
					</Button>
					<Button
						appearance="subtle-link"
						onClick={onCancelClick}
						testId="marketplace-dialog.common.ui.failure-status.cancel-button"
					>
						{formatMessage(messages.cancelButtonLabel)}
					</Button>
				</ButtonGroup>
			</InstallationStatusModal>
		</>
	);
};

export default FailureStatusModal;
